const DAYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
const toMin = (hhmm) => {
    const [h, m] = hhmm.split(":").map(Number);
    return (h ?? 0) * 60 + (m ?? 0);
};
export function localParts(now, timezone) {
    try {
        const f = new Intl.DateTimeFormat("en-GB", {
            timeZone: timezone,
            weekday: "short",
            hour: "2-digit",
            minute: "2-digit",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour12: false,
        });
        const p = {};
        for (const part of f.formatToParts(now))
            p[part.type] = part.value;
        return {
            day: (p["weekday"] ?? "").slice(0, 3).toLowerCase(),
            minutes: (Number(p["hour"]) % 24) * 60 + Number(p["minute"]),
            date: `${p["year"]}-${p["month"]}-${p["day"]}`,
        };
    }
    catch {
        return {
            day: DAYS[now.getDay()],
            minutes: now.getHours() * 60 + now.getMinutes(),
            date: now.toISOString().slice(0, 10),
        };
    }
}
export function isOpen(hours, now = new Date()) {
    if (!hours.enabled)
        return true;
    const { day, minutes, date } = localParts(now, hours.timezone);
    if (hours.holidays.includes(date))
        return false;
    const today = hours.weekly[day] ?? [];
    if (today.some((r) => toMin(r.to) > toMin(r.from)
        ? minutes >= toMin(r.from) && minutes < toMin(r.to)
        : minutes >= toMin(r.from)))
        return true;
    const prev = hours.weekly[DAYS[(DAYS.indexOf(day) + 6) % 7]] ?? [];
    return prev.some((r) => toMin(r.to) <= toMin(r.from) && minutes < toMin(r.to));
}
//# sourceMappingURL=hours.js.map